import { NavLink } from 'react-router-dom';

interface DropdownMenuAnchorProps {
  identifier: string;
  to: string;
  anchorClasses?: string;
  iconClasses?: string;
  children: JSX.Element | JSX.Element[];
}

const DropdownMenuAnchor = ({
  identifier,
  to,
  anchorClasses,
  iconClasses,
  children
}: DropdownMenuAnchorProps) => {
  return (
    <>
      <NavLink
        to={to}
        className={`group p-2 bg-white hover:bg-neutral-200 first:rounded-t last:rounded-b transition-all whitespace-nowrap ${anchorClasses}`}
        id={identifier}
      >
        {iconClasses ? <i className={iconClasses}></i> : <></>}
        {children}
      </NavLink>
    </>
  );
};
export default DropdownMenuAnchor;
